<template>
    <div>
        <b-sidebar v-if="openWithdrawSidebar" v-model="openWithdrawSidebar" no-header-close right backdrop no-close-on-backdrop>
            <template #header>
                <div class="d-flex w-100 border-bottom pb-0">
                    <h2 align-v="start" class="w-100 text-left pb-2">
                        {{ currentWithdraw && currentWithdraw.id ? 'Ver Retirada #' + currentWithdraw.id : 'Nova Retirada' }}
                    </h2>

                    <div class="text-right pb-0">
                        <button @click.prevent="closeWithdrawSidebar()" type="button" class="close" aria-label="Fechar">
                            <span @click.prevent="closeWithdrawSidebar()" class="no no-e-remove"></span>
                        </button>
                    </div>
                </div>
            </template>

            <div class="container mt-2">
                <b-row class="mt-2">
                    <b-col cols="3" align-v="end">
                        <date-picker v-model="formDates.startDate" :disabled="!isNewWithdraw" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd"
                            size="small" :clearable="false" class="mt-1">
                        </date-picker>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col align-h="end" align-v="start" class="text-right mt--1 mb--1">
                        <b-button @click="loadWithdrawPayments()" :disabled="!isNewWithdraw || formDates.startDate == null || formDates.endDate == null" 
                            variant="primary" size="sm">
                            Buscar
                        </b-button>
                    </b-col>
                </b-row>

                <b-row class="mt--2">
                    <b-col cols="3" align-v="start">
                        <date-picker v-model="formDates.endDate" :disabled="!isNewWithdraw" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd"
                            size="small" :clearable="false" class="mt-1">
                        </date-picker>
                    </b-col>
                </b-row>

                <b-row v-if="!isNewWithdraw">
                    <b-col cols="6">
                        <b-button @click="openModalWithdrawBookings()" variant="outline-primary" size="sm" class="mt-2">
                            Listar Reservas
                        </b-button>
                    </b-col>
                </b-row>

                <b-row align-h="between" class="mt-4">
                    <b-col cols="12">
                        <h3 class="mb-2">Informações</h3>

                        <b-row class="mb-0">
                            <b-col cols="6">
                                <b-form-group label="last_pos_cred" label-class="small" class="mb-0">
                                    <CurrencyBaseInput v-model="currentWithdraw.info.last_pos_cred" :modelValue="Number(currentWithdraw.info.last_pos_cred)" :isPercentage="false"
                                        :options="currencyOptions" placeholder="last_pos_cred" size="sm" :disabled="!isNewWithdraw">
                                    </CurrencyBaseInput>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="last_online_cred" label-class="small" class="mb-0">
                                    <CurrencyBaseInput v-model="currentWithdraw.info.last_online_cred" :modelValue="Number(currentWithdraw.info.last_online_cred)" :isPercentage="false"
                                        :options="currencyOptions" placeholder="last_online_cred" size="sm" :disabled="!isNewWithdraw">
                                    </CurrencyBaseInput>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row class="mb-0">
                            <b-col cols="6">
                                 <b-form-group label="online_pix" label-class="small" class="mb-0">
                                   <CurrencyBaseInput v-model="currentWithdraw.info.online_pix" :modelValue="Number(currentWithdraw.info.online_pix)" :isPercentage="false"
                                        :options="currencyOptions" placeholder="online_pix" size="sm" :disabled="!isNewWithdraw">
                                    </CurrencyBaseInput>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="online_deb" label-class="small" class="mb-0">
                                    <CurrencyBaseInput v-model="currentWithdraw.info.online_deb" :modelValue="Number(currentWithdraw.info.online_deb)" :isPercentage="false"
                                        :options="currencyOptions" placeholder="online_deb" size="sm" :disabled="!isNewWithdraw">
                                    </CurrencyBaseInput>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row class="mb-0">
                            <b-col cols="6">
                                <b-form-group label="pos_pix" label-class="small" class="mb-0">
                                    <CurrencyBaseInput v-model="currentWithdraw.info.pos_pix" :modelValue="Number(currentWithdraw.info.pos_pix)" :isPercentage="false"
                                        :options="currencyOptions" placeholder="pos_pix" size="sm" :disabled="!isNewWithdraw">
                                    </CurrencyBaseInput>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="pos_deb" label-class="small" class="mb-0">
                                    <CurrencyBaseInput v-model="currentWithdraw.info.pos_deb" :modelValue="Number(currentWithdraw.info.pos_deb)" :isPercentage="false"
                                        :options="currencyOptions" placeholder="pos_deb" size="sm" :disabled="!isNewWithdraw">
                                    </CurrencyBaseInput>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row class="mb-0">
                            <b-col cols="6">
                                <b-form-group label="online_wallet" label-class="small" class="mb-0">
                                    <CurrencyBaseInput v-model="currentWithdraw.info.online_wallet" :modelValue="Number(currentWithdraw.info.online_wallet)" :isPercentage="false"
                                        :options="currencyOptions" placeholder="online_wallet" size="sm" :disabled="!isNewWithdraw">
                                    </CurrencyBaseInput>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="local_money" label-class="small" class="mb-0">
                                    <CurrencyBaseInput v-model="currentWithdraw.info.local_money" :modelValue="Number(currentWithdraw.info.local_money)" :isPercentage="false"
                                        :options="currencyOptions" placeholder="local_money" size="sm" :disabled="!isNewWithdraw">
                                    </CurrencyBaseInput>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row class="mb-0">
                            <b-col cols="6">
                                <b-form-group label="online_cred" label-class="small" class="mb-0">
                                    <CurrencyBaseInput v-model="currentWithdraw.info.online_cred" :modelValue="Number(currentWithdraw.info.online_cred)" :isPercentage="false"
                                        :options="currencyOptions" placeholder="online_cred" size="sm" :disabled="!isNewWithdraw">
                                    </CurrencyBaseInput>
                                </b-form-group>
                            </b-col>

                            <b-col cols="6">
                                <b-form-group label="pos_cred" label-class="small" class="mb-0">
                                    <CurrencyBaseInput v-model="currentWithdraw.info.pos_cred" :modelValue="Number(currentWithdraw.info.pos_cred)" :isPercentage="false"
                                        :options="currencyOptions" placeholder="pos_cred" size="sm" :disabled="!isNewWithdraw">
                                    </CurrencyBaseInput>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row align-h="start" class="mt-3">
                            <b-col class="text-left">
                                <span>Saldo à vista: <b> {{ formatCurrency(withdrawValues.cash) }}</b></span>
                            </b-col>
                        </b-row>

                        <b-row align-h="start" class="mt-1">
                            <b-col class="text-left">
                                <span>Saldo maquininha: <b> {{ formatCurrency(withdrawValues.pos) }}</b></span>
                            </b-col>
                        </b-row>

                        <b-row align-h="start" class="mt-1">
                            <b-col class="text-left">
                                <span>Vendas no crédito: <b> {{ formatCurrency(withdrawValues.cred) }}</b></span>
                            </b-col>
                        </b-row>

                        <!-- <b-row align-h="start" class="mt-1">
                            <b-col class="text-left">
                                <span>Retirada: <b> {{ formatCurrency(withdrawValues.withdraw) }}</b></span>
                            </b-col>
                        </b-row> -->

                        <!-- <b-row align-h="start" class="mt-1">
                            <b-col class="text-left">
                                <span>Total: <b> {{ formatCurrency(withdrawValues.total) }}</b></span>
                            </b-col>
                        </b-row> -->

                        <b-row align-h="start" class="mt-1">
                            <b-col class="text-left">
                                <span>Valor da Retirada: <b> {{ formatCurrency(currentWithdraw.value) }}</b></span>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12">
                        <b-row align-h="center" class="mt-3 mb-2">
                            <b-col cols="12">
                                <b-form-group label="Status" label-class="small" class="mb-0">
                                    <b-form-checkbox v-model="currentWithdraw.processed" :disabled="!isNewWithdraw" size="sm">
                                        {{ currentWithdraw.processed ? 'Apenas com check-in' : 'Todas as reservas' }}
                                    </b-form-checkbox>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col cols="12">
                                <b-form-group label="last_report_uuid" label-class="small" class="mb-0">
                                    <b-form-input v-model="currentWithdraw.last_report_uuid" :disabled="true" size="sm" placeholder="last_report_uuid">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <b-form-group label="Observação" label-class="small" :class="isNewWithdraw ? 'mb-2' : 'mb-4'">
                                    <b-form-textarea v-model="currentWithdraw.obs" :disabled="!isNewWithdraw" placeholder="Observações" rows="2">
                                    </b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row v-if="isNewWithdraw" class="mt-4 mb-2">
                            <b-col align-h="center" class="text-center">
                                <b-button @click="confirmCreateWithdraw()" variant="outline-primary">Registrar Retirada
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
        </b-sidebar>

        <withdraw-booking-modal v-if="showModalWithdrawBookings" :showModalWithdrawBookings="showModalWithdrawBookings"
            @emitCloseWithdrawBookingsModal="closeWithdrawBookingsModal()">
        </withdraw-booking-modal>

    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import swal from "sweetalert2"
import { DatePicker } from "element-ui"
import WithdrawBookingModal from './WithdrawBookingModal.vue'
import CurrencyBaseInput from '../../components/Inputs/CurrencyBaseInput.vue';

export default {
    name: 'WithdrawSidebar',

    components: {
        DatePicker,
        WithdrawBookingModal,
        CurrencyBaseInput,
    },

    props: {
        openWithdrawSidebar: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            formDates: { startDate: '', endDate: '', }, showModalWithdrawBookings: false,
            currencyOptions: {
                locale: "pt-BR", currency: "BRL", currencyDisplay: "symbol", precision: 2,
                hideCurrencySymbolOnFocus: false, hideGroupingSeparatorOnFocus: false, hideNegligibleDecimalDigitsOnFocus: false,
                autoDecimalDigits: true, useGrouping: false, accountingSign: false
            },
        }
    },

    computed: {
        ...mapGetters('withdraw', {
            isLoading: 'getIsLoading',
            currentWithdraw: 'getCurrentWithdraw',
            // withdrawPaymentsList: 'getWithdrawsPaymentsList',
            withdrawBookingsList: 'getWithdrawBookingsList',
        }),

        isNewWithdraw(){ return this.currentWithdraw && this.currentWithdraw.id ? false : true },
        
        withdrawValues(){
            let withdraw = 0
            let total = 0
            let cred = 0
            let pos = this.currentWithdraw.info.pos_deb + this.currentWithdraw.info.pos_pix
            let cash = this.currentWithdraw.info.online_deb + this.currentWithdraw.info.online_pix + this.currentWithdraw.info.online_wallet

            this.withdrawBookingsList.forEach(item=>{
                if(item.pm != 'credit'){
                    withdraw += item.final_value
                    total += item.value
                }else{
                    cred += item.final_value
                }

            })

            return { cred: cred, pos: pos, cash: cash, withdraw: withdraw, total: total  }
        },

    },

    watch: {
        ['formDates.startDate'](newValue, oldValue){
            if(newValue && this.isNewWithdraw){
                this.currentWithdraw.info.period.start = moment(newValue).format('YYYY-MM-DD');
            }
        },

        ['formDates.endDate'](newValue, oldValue){
            if(newValue && this.isNewWithdraw){
                this.currentWithdraw.info.period.end = moment(newValue).format('YYYY-MM-DD');
            }
        },
    },

    methods: {
        ...mapActions('withdraw', [
            'fetchWithdrawBookings',
            'fetchWithdrawPaymentsForAttractions',
            'saveWithdrawForAttraction',
            'withdrawStoreCommit',
        ]),

        formatCurrency(value){
            const numero = Number(value)
            return numero.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },

        closeWithdrawSidebar(){ this.$emit('closeWithdrawSidebar') },

        async loadWithdrawBookings(){
            if(this.currentWithdraw && this.currentWithdraw.uuid){
                await this.fetchWithdrawBookings({ uuid: this.currentWithdraw.uuid })
            }
        },

        async loadWithdrawPayments(){
            if(!this.currentWithdraw.uuid){
                const payload = {
                    place_uuid: this.currentWithdraw.placeUuid,
                    start_date: this.formDates.startDate,
                    end_date: this.formDates.endDate,
                    checked_in: false,
                    ref_report_uuid: this.currentWithdraw.last_report_uuid,
                    obs: "...",
                    save_report: false,
                }

                await this.fetchWithdrawPaymentsForAttractions(payload)
                    .catch(() => {
                        this.$notify({ message: 'Erro ao carregar pagamento de retiradas.', duration: 3000, type: 'warning' })
                    })
            }
        },

        confirmCreateWithdraw(){
            if(this.isNewWithdraw && this.currentWithdraw.info.period.start.length > 0 && this.currentWithdraw.info.period.end.length > 0){
                swal.fire({
                    title: `Registrar nova retirada?`,
                    text: `Total: ${this.formatCurrency(this.withdrawValues.total)}`,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Registrar',
                    confirmButtonColor: '#D93051;',
                    cancelButtonText: 'Cancelar',
                    reverseButtons: true,
                    cancelButtonColor: 'secondary',
                    // type: 'default'
                })
                .then((async result => {
                    if (result.isConfirmed) {
                        const payload = {
                            place_uuid: this.currentWithdraw.placeUuid,
                            start_date: this.formDates.startDate,
                            end_date: this.formDates.endDate,
                            checked_in: this.currentWithdraw.processed,
                            ref_report_uuid: this.currentWithdraw.last_report_uuid,
                            obs: this.currentWithdraw.obs,
                            save_report: true,
                        }

                        await this.fetchWithdrawPaymentsForAttractions(payload)
                            .then(() => {
                                this.$notify({ message: 'Sucesso ao registrar pagamento de retiradas.', duration: 3000, type: 'success' })
                                this.closeWithdrawSidebar()
                                this.$emit('reloadWithdraws')
                            })
                            .catch(() => {
                                this.$notify({ message: 'Erro ao registrar pagamento de retiradas.', duration: 3000, type: 'warning' })
                            })
                    }
                }))
            }
        },

        openModalWithdrawBookings(){ this.showModalWithdrawBookings = true },
        closeWithdrawBookingsModal(){ this.showModalWithdrawBookings = false },

    },

    async mounted() {
        this.formDates.startDate = moment(this.currentWithdraw.info.period.start).format('YYYY-MM-DD');
        this.formDates.endDate = moment(this.currentWithdraw.info.period.end).format('YYYY-MM-DD');

        await this.loadWithdrawBookings()
    },

}
</script>